module.exports = __webpack_public_path__ + "2a883396d80aa295d2cd6da7726c5ff6.pdf";